
import View from 'ln/view/View';
import VideoPlayer from './VideoPlayer';
import Scanner from 'ln/view/Scanner';
import TimeMonitor from './TimeMonitor';
import ProgressBar from './controls/ProgressBar';
import ChapterControl from './controls/ChapterControl';
import { all } from './defaultViews';

class LernVideo extends View {

    public player:VideoPlayer;
    public scanner:Scanner;
    public monitor:TimeMonitor;

    public constructor() {
        super();
        this.defaultTemplate = 'lv.lernvideo';
        this.monitor = new TimeMonitor();
        this.scanner = new Scanner();
    }

    public init() {
        this.player = new VideoPlayer().render( this.node.js( 'video' ) ) as VideoPlayer;
        this.player.time.add( this.monitor.update.bind( this.monitor ) );

        this.scanner.scan( this.node, this );

    }

    public load( url:string ) {
        this.player.load( url );
    }

    public setupViews(){
        all( this );
        return this;
    }

    public get progressBar():ProgressBar {
        return this.scanner.first( 'video-progress', this.node ) as ProgressBar;
    }

    public get ChapterControl():ChapterControl {
        return this.scanner.first( 'video-chapter-control', this.node ) as ChapterControl;
    }

}

export default LernVideo;